export default __webpack_public_path__ + "static/mock-d8f2522fa5b14ebe3e4f071c74fbae1b.png";